import "normalize.css";
import "../scss/style.scss";

$(function() {
  // スライド参照先取得
  var qa = $("#lp-qa #lp-qa-body");
  // Slick初期化イベント割当
  qa.on("init", function() {
    qa.find(".sec2").removeClass("none");
  });
  // Slick初期化
  qa.slick({
    arrows: false,
    infinite: false
  })

  // 戻るボタン参照先取得
  var button_prev = $("#lp-qa nav button.with-icon.prev");
  // ボタンイベント割当
  qa.on("afterChange", function() {
    var current = qa.slick("slickCurrentSlide");
    if (current == 0) {
      button_prev.hide();
    } else {
      button_prev.show();
    }
  });
  button_prev.on("click", function() {
    qa.slick("slickPrev");
  });

  // スライド削除処理定義
  var removeSlides = function() {
    qa.slick("slickRemove", 4);
    qa.slick("slickRemove", 3);
    qa.slick("slickRemove", 2);
  }
  // スライド割当処理定義
  var addSlides = function(template) {
    removeSlides();
    var next = $(template);
    next.find(".answer").on("click", function() {
      $(this).parents(".answers").find(".selected").removeClass("selected");
      $(this).parent().addClass("selected");
      qa.slick("slickNext");
    });
    next.children().each(function(i, e){
      qa.slick("slickAdd", e);
    });
    qa.slick("slickNext");
  }

  // スタートボタン
  qa.find(".button-start").on("click", function(){
    qa.slick("slickNext");
  });
  // １問目回答
  qa.find(".sec2-answer-1").on("click", function(){
    $(this).parents(".answers").find(".selected").removeClass("selected");
    $(this).parent().addClass("selected");
    addSlides($("#lp-qa #lp-qa-next1").html());
  });
  qa.find(".sec2-answer-2").on("click", function(){
    $(this).parents(".answers").find(".selected").removeClass("selected");
    $(this).parent().addClass("selected");
    addSlides($("#lp-qa #lp-qa-next2").html());
  });
  qa.find(".sec2-answer-3").on("click", function(){
    $(this).parents(".answers").find(".selected").removeClass("selected");
    $(this).parent().addClass("selected");
    addSlides($("#lp-qa #lp-qa-next3").html());
  });
  qa.find(".sec2-answer-4").on("click", function(){
    $(this).parents(".answers").find(".selected").removeClass("selected");
    $(this).parent().addClass("selected");
    addSlides($("#lp-qa #lp-qa-next4").html());
  });
  qa.find(".sec2-answer-5").on("click", function(){
    $(this).parents(".answers").find(".selected").removeClass("selected");
    $(this).parent().addClass("selected");
    addSlides($("#lp-qa #lp-qa-next5").html());
  });
});